import styled from 'styled-components';
import { Text, Box, Flex } from 'rebass/styled-components'

const ResponseBubbleStyled = styled.div`
  background:  #344f79;
  color: white;
  border-radius: 0 12px 12px 12px;
  padding: 12px;
  max-width: calc(100% - 74px);
  box-shadow: rgba(52, 79, 121, 0.45) 0px 3px 16px;
  & > a {
    color: white !important;
  }
`;

const CustomerBubbleStyled = styled(Box)`
  background:  #D7E3F5;
  color: #344f79;
  border-radius: 12px 12px 0 12px;
  padding: 12px;
  /* max-width: 80%; */
  box-shadow: rgba(52, 79, 121, 0.45) 0px 3px 16px;
  & > a {
    color: white !important;
  }
`;

const BotBubbleStyled = styled.div`
  background: #f9a394;
  color: white;
  border-radius: 0 12px 12px 12px;
  padding: 12px;
  max-width: 90%;
  box-shadow: rgba(52, 79, 121, 0.45) 6px 6px 16px;
  & > a {
    color: white !important;
  }
`;

const FromStyled = styled(Text)`
  font-size: 16px;
  font-weight: 600;
`;

const MessageTimeStyled = styled(Text)`
  font-size: 12px;
  align-self: center;
  flex-grow: 1;
  text-align: right;
  margin-left: 12px;
`;

const MessageTextStyled = styled(Text)`
  word-wrap: break-word;
  /* white-space: pre-line; */
`;

const MessageAvatarStyled = styled.div<{ photoUrl: string }>`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  background-image: ${(props: any) => `url(${props.photoUrl})` || ''};
  background-size: cover;
`;

const MessageAvatarNoPicStyled = styled(Flex)`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  background-color: #f9a394;
  justify-content: center;
  align-items: center;
`;

const SmsStyleBubbleMe = styled(Box)`
  /* max-width: 80%; */
  border-radius: 28px 0 0 28px;
  padding: 16px;
  background-color: white;
  font-size: 14px;
  &.top {
    border-top-right-radius: 28px;
  }
  &.bottom {
    border-bottom-right-radius: 28px;
  }
`

const SmsStyleBubbleNoteMe = styled(Flex)`
  /* max-width: 80%; */
  border-radius: 28px 0 0 28px;
  padding: 16px;
  background-color: #FFD2CA;
  font-size: 14px;
  flex-direction: column;
  &.top {
    border-top-right-radius: 28px;
  }
  &.bottom {
    border-bottom-right-radius: 28px;
  }
`

const SmsStyleBubbleNoteOther = styled(Flex)`
  max-width: 80%;
  border-radius: 0 28px 28px 0;
  padding: 16px;
  background-color: #FFD2CA;
  font-size: 14px;
  flex-direction: column;
  &.top {
    border-top-left-radius: 28px;
  }
  &.bottom {
    border-bottom-left-radius: 28px;
  }
`

const SmsStyleBubbleOther = styled(Box)`
  /* max-width: 80%; */
  width: fit-content;
  border-radius: 0 28px 28px 0;
  padding: 16px;
  background-color: #1E46D4;
  color: white;
  font-size: 14px;
  &.top {
    border-top-left-radius: 28px;
  }
  &.bottom {
    border-bottom-left-radius: 28px;
  }
`

const SmsStyleBubbleWorkflow = styled(Flex)`
  max-width: 80%;
  min-width: 80%;
  border-radius: 28px;
  padding: 8px 16px;
  background-color: #7385A3;
  color: white;
  font-size: 14px;
`

export {
  ResponseBubbleStyled,
  CustomerBubbleStyled,
  BotBubbleStyled,
  FromStyled,
  MessageTimeStyled,
  MessageTextStyled,
  MessageAvatarStyled,
  MessageAvatarNoPicStyled,
  SmsStyleBubbleMe,
  SmsStyleBubbleOther,
  SmsStyleBubbleWorkflow,
  SmsStyleBubbleNoteOther,
  SmsStyleBubbleNoteMe
};
